// The household's year (#379, #390), mirroring the backend's FinancialYear: April–March (4, the
// default) or January–December (1). "Year N" starts in year N — FY 2025–26 is year 2025.

export type FyStartMonth = 1 | 4

/** The financial year an ISO date (yyyy-MM-dd) falls in. */
export function financialYearOf(isoDate: string, fy: FyStartMonth): number {
  const year = Number(isoDate.slice(0, 4))
  const month = Number(isoDate.slice(5, 7))
  return month >= fy ? year : year - 1
}

/** "FY 2025–26" for April–March households, "2025" for January–December ones. */
export function financialYearLabel(year: number, fy: FyStartMonth): string {
  return fy === 1 ? String(year) : `FY ${year}–${String((year + 1) % 100).padStart(2, '0')}`
}
